import { render, staticRenderFns } from "./NavbarSettings.vue?vue&type=template&id=6523ad10&scoped=true"
import script from "./NavbarSettings.vue?vue&type=script&lang=js"
export * from "./NavbarSettings.vue?vue&type=script&lang=js"
import style0 from "./NavbarSettings.vue?vue&type=style&index=0&id=6523ad10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523ad10",
  null
  
)

export default component.exports